import React from "react";
import "../../styles/m3d-vantagens.css";

export default function ComoFunciona() {
  return (
    <section className="como-funciona">
      <h2>Como funciona</h2>

      <div className="steps">

        <div className="step-card">
          <div className="step-number">01</div>
          <p>Peça um orçamento</p>
        </div>

        <div className="step-card">
          <div className="step-number">02</div>
          <p>Ganhe pontos automaticamente</p>
        </div>

        <div className="step-card">
          <div className="step-number">03</div>
          <p>Resgate seus prêmios</p>
        </div>

      </div>
    </section>
  );
}
